import { Pipe, PipeTransform } from '@angular/core';
import { CompanyFlagEntity, CompanyFlagHistoryEntity } from '@nk/data-entities-lib';

@Pipe({
  name: 'flagEndDate',
})
export class FlagEndDatePipe implements PipeTransform {
  public transform(flag: CompanyFlagEntity | CompanyFlagHistoryEntity): Date | null {
    return 'flag_end_date' in flag ? flag.flag_end_date : null;
  }
}
